// extracted by mini-css-extract-plugin
module.exports = {"rcorners3":"Success_rcorners3__1vhtE","centerDiv":"Success_centerDiv__y0FNH"};